class ExpandableSection extends HTMLElement {
  section: HTMLElement | null = null;
  toggleBtn: HTMLElement | null = null;

  connectedCallback() {
    this.section = this.querySelector('#expandable-section');
    this.toggleBtn = this.querySelector('#expand-toggle');

    this.toggleBtn?.addEventListener('click', () => {
      if (this.section.classList.contains('overflow-hidden')) {
        this.section.classList.remove('overflow-hidden');
        this.section.classList.remove('h-[354px]');
        this.section.classList.add('overflow-visible');
        this.toggleBtn.classList.add('expanded');
      } else {
        this.section.classList.remove('overflow-visible');
        this.section.classList.add('overflow-hidden');
        this.section.classList.add('h-[354px]');
        this.section.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
        this.toggleBtn.classList.remove('expanded');
      }
    });
  }
}

if (!customElements.get('expandable-section')) {
  customElements.define('expandable-section', ExpandableSection);
}
